/**
 * Scrollup
 */

 $(function () {
     if ($.scrollUp !== undefined) {
         $.scrollUp({
             scrollName: 'c-scrollup', // Element ID
             scrollDistance: 300,      // Distance from top/bottom before showing element (px)
             scrollSpeed: 300,         // Speed back to top (ms)
             scrollText: 'nach oben', // Text for element, can contain HTML
         });
     }
 });
